import { useParams } from "react-router-dom";
import { Cotizador as MultiCotizador } from "../../Pages/Multicotizador/Cotizador";
import { Cotizador as CotizadorAuto } from "../../Pages/Auto/Cotizador";
import { companiaDeCotizador } from "./cotizadorDeCompania";

/** "/:rubroURL" atiende al multicotizador y a las landings de compañía (/sancor-cotizador) de AR y UY. */
export const RubroOCompania = ({ pais }: { pais?: string }) => {
  const { rubroURL } = useParams();
  if ((pais === "AR" || pais === "UY") && companiaDeCotizador(rubroURL)) {
    return <CotizadorAuto step={0} subStep={1} />;
  }
  return <MultiCotizador />;
};
